<template>
  <div class="content">
    <div class="con_bg" :style="{'background-image':'url('+contentBg+')'}">
      <!--专题介绍 -->
      <div class="activity">
        <div class="actTit">
          <div class="titImg">
            <img :src="titImg" />
          </div>

          <p class="text" :style="{'background-image':'url('+textBg+')'}">
            <span>“鼙鼓动时雷隐隐，兽头凌处雪微微。”唐代诗人卢肇用一首《竞渡诗》写出了端午佳节龙舟竞渡的非凡盛况。纵观历代文人墨客，他们从不吝于对端午的纵情描绘。中华文化源远流长，传统节日内涵深邃丰厚，端午习俗在我国各地也不尽相同，赛龙舟、吃粽子、悬艾叶、佩香囊……时至今日，关于端午的文化记忆更是不胜枚举。</span>

            <span>在端午佳节之际，书香中国平台特为大家精选多部相关作品，并同步上线“赛龙舟”小游戏，旨在增进大家对中国传统文化的了解，在传统节日的浓郁氛围中感受文化魅力，增强民族自豪感和爱国情怀。</span>
          </p>
        </div>
      </div>

      <!-- 奖品设置 -->
      <div class="info">
        <h2 class="htitle">
          <img :src="titImg1" alt />
        </h2>
        <div class="dec">
          <div class="prizeBox">
            <div class="prizeList">
              <div class="prize">
                <img :src="prize1" class="img" />
              </div>
              <p class="level">一等奖 1名</p>
              <p class="name">国画礼盒套装</p>
              <!-- <p class="sm">（礼品以实物为准）</p> -->
            </div>
            <div class="prizeList">
              <div class="prize">
                <img :src="prize2" class="img" />
              </div>
              <p class="level">二等奖 3名</p>
              <p class="name">听书机</p>
              <!-- <p class="sm">（礼品以实物为准）</p> -->
            </div>
            <div class="prizeList">
              <div class="prize">
                <img :src="prize3" class="img" />
              </div>
              <p class="level">三等奖 10名</p>
              <p class="name">蓝牙小音箱</p>
              <!-- <p class="sm">（礼品以实物为准）</p> -->
            </div>
          </div>

          <div class="activeDec">
            <p>1、活动时间：2022年6月1日至2022年6月30日</p>
            <p>2、获奖结果公布日期：2022年7月1日至7月10日进行后续的统计和颁奖工作。</p>
          </div>
          <div class="card">
            <img :src="card" alt />
            <p>扫码参与游戏</p>
          </div>
          <div class="mark"></div>
        </div>
      </div>

      <!-- <div class="mainCon">
        <div class="main">
          <ul class="booklist" id="list">
            <li class="bookLi" v-for="(item,index) in bookList" :key="index">
              <div class="bookImg">
                <a :href="item.url" target="_blank">
                  <img :src="item.cover" />
                </a>
              </div>
              <div class="bookInfor">
                <h3 class="bookName">
                  <a :href="item.url" target="_blank">{{item.name}}</a>
                </h3>
                <p class="author">{{item.author}}</p>
                <p class="intro">{{item.intro}}</p>
                <p>
                  <a :href="item.url" target="_blank" class="btn">立即阅读</a>
                </p>
              </div>
            </li>
          </ul>
          <div class="z1"></div>
        </div>
      </div>-->
      <div class="mainCon">
        <h2 class="htitle">
          <img :src="titImg3" alt />
        </h2>
        <div class="main" :style="{'background-image':'url('+bookBg+')'}">
          <ul class="booklist" id="list">
            <li class="bookLi" v-for="(item,index) in bookList" :key="index">
              <div class="bookImg">
                <a :href="item.url" target="_blank">
                  <img :src="item.cover" />
                </a>
              </div>
              <div class="bookInfor">
                <h3 class="bookName">
                  <a :href="item.url" target="_blank">{{item.name}}</a>
                </h3>
                <p class="author">{{item.author}}</p>
                <p class="intro">{{item.intro}}</p>
                <p>
                  <a :href="item.url" target="_blank" class="btn">立即阅读</a>
                </p>
              </div>
              <!-- <div class="jianjie">内容简介</div>
              <div class="intro">{{item.intro}}</div>-->
            </li>
          </ul>
          <div class="z1"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bookList } from "../../assets/js/data";
export default {
  name: "content",
  data() {
    return {
      returnUrl: "",
      contentBg: "",
      titImg: require("../../assets/img/pc/1.png"),
      textBg: require("../../assets/img/pc/textBg.png"),
      titImg1: require("../../assets/img/pc/2.png"),
      prize1: require("../../assets/img/pc/pic1.png"),
      prize2: require("../../assets/img/pc/pic2.png"),
      prize3: require("../../assets/img/pc/pic3.png"),
      titImg3: require("../../assets/img/pc/3.png"),
      card: require("../../assets/img/pc/card.png"),
      bookBg: require("../../assets/img/pc/bookBg.png"),
      list: []
    };
  },
  computed: {
    bookList() {
      return bookList;
    }
  },
  methods: {
    getUrl() {}
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.content {
  padding: 0 0;

  margin: 0 auto;
  position: relative;
  .con_bg {
    width: 100%;
    background-size: 100% 100%;
    padding: 0 0 0.6rem;
  }

  .activity {
    width: 15.06rem;
    margin: 0 auto;
    margin-bottom: 0.1rem;
    .actTit {
      width: 100%;
      .titImg {
        padding: 0 1.8rem;
        margin-bottom: 0.1rem;
        img {
          height: 2.8rem;
        }
      }

      // .text {
      //   padding: 0.49rem 0.57rem;
      //   line-height: 0.3rem;
      //   font-weight: 400;
      //   color: #0d1e1a;
      //   text-align: left;
      //   background: rgba(255, 255, 255, 0.4);
      //   border-radius: 40px;
      // }
      .text {
        background-size: 100% 100%;
        padding: 1.01rem 0.85rem 0.4rem 0.85rem;
        color: #fbedaf;
        text-align: left;
        z-index: 100;
        // padding: 0.52rem 0.39rem;
        // background: rgba(255, 255, 255, 0.4);
        // border-radius: 20px;
        // text-align: left;
        font-size: 0.36rem;
        line-height: 0.48rem;
        span {
          display: inline-block;
          margin-bottom: 0.4rem;
        }
        // color: #14302a;
      }
    }
  }
  .htitle {
    margin-bottom: 0.2rem;
    img {
      height: 2.8rem;
    }
  }
  .info {
    width: 12rem;
    margin: 0 auto;
    margin-bottom: 0.28rem;

    .dec {
      width: 100%;

      padding: 0 0.57rem;
      .activeDec {
        text-align: left;
        margin-bottom: 0.4rem;
        p {
          color: #fff;
        }

        padding-left: 0.5rem;
        h3 {
          font-size: 0.28rem;
          margin-bottom: 0.2rem;
        }
        p {
          margin: 0;
          line-height: 0.34rem;
        }
        .bold {
          font-weight: bold;
        }
      }
      .card {
        width: 2.88rem;

        margin: 0 auto;
        img {
          width: 2.88rem;
          height: 2.88rem;
          margin-bottom: 0.2rem;
        }
        p {
          color: #fff;
        }
      }
      .prizeBox {
        display: flex;
        margin-bottom: 0.44rem;
        justify-content: space-between;
      }
      .prize {
        height: 3.08rem;
        margin-bottom: 0.26rem;
        img {
          width: 3.08rem;
          height: 3.08rem;
        }
      }
      p {
        margin-bottom: 0.2rem;
        color: #fbf0b8;
        font-size: 0.28rem;
      }
      .level {
        font-size: 0.22rem;
        font-weight: bold;
      }
      .sm {
        margin-bottom: 0.3rem;
        font-size: 0.16rem;
      }
    }
    .gobtn {
      display: inline-block;
      height: 0.64rem;
      margin-bottom: 0.3rem;
      img {
        // width: 2.5rem;
        height: 0.64rem;
      }
    }
    .mark {
      padding: 0 0.3rem;
      line-height: 0.38rem;
      text-align: left;
      color: #405656;
    }
  }
  .mainCon {
    width: 14.3rem;
    margin: 0 auto;
  }
  .main {
    width: 14.3rem;
    background-size:100% 100% ; padding: 0.8rem 1.84rem 0.48rem;
  }
  .booklist {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      width: 48%;
      display: flex;
      margin-bottom: 0.32rem;
      .bookImg {
        width: 1.74rem;
        height: 2.32rem;
        margin-right: 0.2rem;
        a {
          display: inline-block;
          width: 100%;
          height: 100%;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .bookInfor {
        flex: 1;
        color: #0d1e1a;
        text-align: left;
        .bookName {
          font-size: 0.2rem;

          font-weight: bold;
          color: #0d1e1a;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .author {
          font-size: 0.16rem;
          line-height: 0.6rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .intro {
          height: 0.87rem;
          font-size: 0.16rem;
          line-height: 0.3rem;
          margin-bottom: 0.14rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          line-clamp: 3;
          -webkit-box-orient: vertical;
        }

        .btn {
          font-size: 0.16rem;
          display: inline-block;
          width: 1.3rem;
          height: 0.4rem;
          line-height: 0.4rem;
          text-align: center;
          background: #FED79F;
          border-radius: 4px;
          color: #BD2025;
        }
      }
    }
  }
}
</style>
